import React, { FC } from 'react';
import { CatalogListSkeleton } from 'src/components/widgets/catalogList';
import {
    SkeletonBlock,
    SkeletonLeftSidebar,
    SkeletonLeftSidebarContent,
    SkeletonLeftSidebarLayout,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack
} from 'src/components/widgets/skeleton';
import styled from 'styled-components';

const ImagesSkeletonShell = styled(SkeletonPageShell)``;

const ImagesSkeletonHeader = styled(SkeletonPageHeader)``;

const ImagesSkeletonLayout = styled(SkeletonLeftSidebarLayout)``;

const ImagesSidebarSkeleton = styled(SkeletonLeftSidebar)``;

const ImagesToolbarSkeleton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 12px;
    min-width: 0;

    @media (max-width: 700px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const ImagesPageSkeleton: FC = () => (
    <ImagesSkeletonShell aria-hidden='true'>
        <ImagesSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(300px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(560px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonRow $gap='8px'>
                <SkeletonBlock $width='72px' $height='36px' $radius='6px' />
                <SkeletonBlock $width='106px' $height='36px' $radius='6px' />
            </SkeletonRow>
        </ImagesSkeletonHeader>
        <ImagesSkeletonLayout>
            <ImagesSidebarSkeleton>
                <SkeletonStack $gap='14px'>
                    <SkeletonBlock $width='74%' $height='16px' />
                    {Array.from({ length: 6 }).map((_, index) => (
                        <SkeletonStack key={index} $gap='8px'>
                            <SkeletonRow $gap='10px'>
                                <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                                <SkeletonBlock $width={index % 2 === 0 ? '78%' : '58%'} $height='13px' />
                            </SkeletonRow>
                            {index < 3 && <SkeletonBlock $width='62%' $height='11px' $margin='0 0 0 28px' />}
                        </SkeletonStack>
                    ))}
                </SkeletonStack>
            </ImagesSidebarSkeleton>
            <SkeletonLeftSidebarContent>
                <ImagesToolbarSkeleton>
                    <SkeletonBlock $width='min(500px, 100%)' $height='28px' $radius='6px' />
                </ImagesToolbarSkeleton>
                <ImagesToolbarSkeleton>
                    <SkeletonRow $gap='10px'>
                        <SkeletonBlock $width='104px' $height='28px' $radius='6px' />
                        <SkeletonBlock $width='84px' $height='28px' $radius='6px' />
                    </SkeletonRow>
                    <SkeletonBlock $width='120px' $height='18px' />
                </ImagesToolbarSkeleton>
                <CatalogListSkeleton itemsCount={15} />
            </SkeletonLeftSidebarContent>
        </ImagesSkeletonLayout>
    </ImagesSkeletonShell>
);

export const BackgroundGalleryPageSkeleton: FC = () => <ImagesPageSkeleton />;
